import React, { useEffect, useState } from "react";
import { Modal } from 'antd';
import styles from "./scss/meetingslist.module.scss";
import { URButton } from "../../../shared/widgets/button";
import usrcirclegrey from "../../../styles/images/meetingusericon.svg";
import usrcircleactive from "../../../styles/images/PersonCirclewhite.svg";
import copyinvite  from "../../../styles/images/copyinvite.svg"
//*import { URInput } from "../../../shared/widgets/input";
//*import { Link } from "react-router-dom";
import { getMeetingLists, getVideoRecordingLists, scrollgetMeetingLists, updateMeetingRead } from "../../../base/meetingService/apiService";
import store from "../../../context/store/store";
import {
  convertDuration, fetchClips, findHostName, searchMeetingDescriptionHighlight,
  searchMeetingHostNameHighlight,
  searchMeetingTitleHighlight,
  setRecClips,
  timeStampConverterMeeting
} from "../../../base/callService/common";
import moment from "moment";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../styles/images/Lottie Animation.json";
import { URChatLeftSkeleton } from "../../../shared/skeletonLoading/chatLeftSkeleton";
//*import { copyTemplate } from "../../../base/meetingService/utils";
import { ccTabChange, storeActions, storeCurrentMeetingDetail, storeEditMOM, storeEditMOMCopy, storeMeetingPage, storeMOM, storePerformance,storeVideoRecordingList,storePreviousMeetingDetail, storeTranscript, storeWindowState } from "../../../base/meetingService/meetingStoreServices";
import { useSelector } from "react-redux";
import { LoginState } from "../../../models/model";
import { RRuleTimeCal } from "../../../base/meetingService/utils/meetingServices";
import CopyInvitePopUp from "../meetingWidgets/popUp/copyInvitePopUp";
import _ from "lodash";
//import { isConditionalExpression } from "typescript";
import NoContent from "../../../shared/widgets/noContent";
import noResult from "../../../styles/images/empty_states/nomeetingsfound.svg";
import { UserDetails } from "../../../models/model";
import { useHistory } from "react-router-dom";
import { Types } from "../../../context/action/action";


type meetListState = {
  isClear: boolean;
  meetingListState: any;
  filterType: string;
  tempList: any;
  doneList: any;
  isModalVisible: boolean;
  isCopyModal: boolean;
  // notifyStatus: boolean;
  // audioStatus: boolean;
};

const MeetingsLists = React.memo(() => {
  const [meetListState, setMeetListState] = useState<meetListState>({
    isClear: false,
    meetingListState: [],
    filterType: "Upcoming",
    tempList: [],
    doneList: [],
    isModalVisible: false,
    isCopyModal: false
    // notifyStatus: false,
    // audioStatus:false
  });
  

 
  const history = useHistory();
  let { meetingList, isLeftBarLoading, detailPage,currentMeetingDetailPage } = store.getState().meetingReducer || [];
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { getListInput } = meetingReducer;
  let { userdetails }: LoginState = store.getState().loginReducer;
  let previousMeetingArray: any = ['Completed', 'Missed', 'Cancelled'];
  let { isModalVisible, isCopyModal } = meetListState;
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  //var travelTime = (moment(detailPage.lastModifiedDate).add(1, 'hours').format('hh:mm A')).split(" ");
  //console.log('loggedUser.sip_login_id --- ', loggedUser.sip_login_id);
  const handleCancel = () => {
    setMeetListState({ ...meetListState, isModalVisible: false });

  };

  const copyInvitationModal = (status:boolean) => {
    setMeetListState({ ...meetListState, isCopyModal: status });
  };
  
  // const handleOk3 = () => {
  //   copyTemplate('copyMeeting');
  //   toastInformation('Meeting invitation copied', 'success');
  //   setMeetListState({ ...meetListState, isCopyModal: false });
  // };
  // const handleCancel3 = () => {
  //   setMeetListState({ ...meetListState, isCopyModal: false });
  // };

  const handleScroll = (e: any) => {
    if (!isLeftBarLoading) {
     // const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
      const bottom = ((e.target.scrollHeight - Math.abs(e.target.scrollTop)) - e.target.clientHeight);
      if (bottom < 2) {
        //leftBarLoader(true);
        let data: any = {};
        data.offset = getListInput.offset + 10;
        data.limit = getListInput.limit;
        data.filter = getListInput.filter;
        data.searchText = getListInput.searchText;
        data.sort = getListInput.sort;
        scrollgetMeetingLists(data);
      }
   }
  };

 


  const setDetailPage = (list: any) => {
    // storeMeetingPage(list);
    storeMOM([],[],[],[], true);
    storeTranscript([],false,0);
    storeEditMOM("",false);
    storeEditMOMCopy("",false);
    storeActions([],false,0);
    storeVideoRecordingList([])
    storePerformance([],false,0);
    ccTabChange("1");
    //console.log("Set DETAILS CALLING>>>>>");
    history.push("/meeting");
    store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:true
      }
    })
    updateMeetingRead(list?.uuid);
    let recdata: any ={};
    recdata.offset = 0;
    recdata.limit = 10;
    recdata.search = list.uuid;
    getVideoRecordingLists(recdata);
    fetchClips(list.uuid);
    setRecClips([]);
      if(!_.isEmpty(currentMeetingDetailPage)){
        storeMeetingPage(list);
        storePreviousMeetingDetail(currentMeetingDetailPage);
        storeCurrentMeetingDetail(list);

      }
      else{
        storeCurrentMeetingDetail(list);
        storeMeetingPage(list)
      }
      storeWindowState("meetingDetails");
  };

  const storeMeetingDetail = (list: any) => {
    // storeMeetingPage(list);
    storeMOM([],[],[],[], true);
    storeTranscript([],false,0);
    storeEditMOM("",false);
    storeEditMOMCopy("",false);
    ccTabChange("1");
      history.push("/meeting")
      let recdata: any ={};
      recdata.offset = 0;
      recdata.limit = 10;
      recdata.search = list.uuid;
      getVideoRecordingLists(recdata);
    if (!_.isEmpty(currentMeetingDetailPage)) {
      storePreviousMeetingDetail(currentMeetingDetailPage)
      storeMeetingPage(list)
      storeCurrentMeetingDetail(list)
    }
    else{
      storeCurrentMeetingDetail(list);
      storeMeetingPage(list)
    }
  }

  useEffect(() => {
    let data: any = {};
    data.offset = 0;
    data.limit = 10;
    data.filter = getListInput.filter;
    data.searchText = '';
    data.sort = '1';
    getMeetingLists(data);

  }, []);

  useEffect(()=>{
   // updateMeetingTotalBatch();
    //console.log('meetingList test ------',meetingList)
    //console.log('meetingTotalCount -----', meetingTotalCount)
  },[JSON.stringify(meetingList)])

  const redirectToMeeting = (elem:any) => {
    if (!previousMeetingArray.includes(elem.status)) {
      let replaced_url: any= elem.invite_url?.includes("stagemeet") ? `${elem.invite_url}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`: `${elem.invite_url?.replace('meet.unifiedring', 'meet.worktual')}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`;
     window.open(replaced_url, '_blank'); 
     store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:true
      }
    })
    updateMeetingRead(elem?.uuid);
    }
    else return false;
  };
  
  const reScheduleMeeting = (elem: any) => {
    storeMeetingPage(elem);
    storeWindowState("reschedule"); 
  };

  return (
    <>
    <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`} onScroll={handleScroll}>
      <>
        {Array.isArray(meetingList) && meetingList.length > 0 ? <>
          <div className={`${styles.meetingsList}`}>
            {meetingList?.map((list: any, index: any) => {
              // const currentDate =  moment(new Date()).format("YYYY-M-DD");
              const currentTimeStamp=Date.now();  /// Current Timestamp
              // const startDate = moment(currentTimeStamp);
              // const timeEnd = moment(list.start_timestamp);
              // const timestampDate=new Date(list.start_timestamp).getDate();
              // const timestampMonth=new Date(list.start_timestamp).getMonth();
              // const timestampYear=new Date(list.start_timestamp).getFullYear();
             // const timestampStartDate= moment (new Date(timestampYear, timestampMonth, timestampDate)).format('YYYY-M-DD');
             // const timestampCreatedDate= moment (new Date(timestampYear, timestampMonth, timestampDate)).format('DD MMM YYYY hh:mm');
             // const diff = timeEnd.diff(startDate);
             // const diffDuration = moment.duration(diff);
              const subTimpstampval= list.start_timestamp-currentTimeStamp;
              const diffTimeStamp=Math.floor(subTimpstampval/60000);
              //console.log('subval', Math.floor(subval/60000));
              // if(timestampStartDate!==currentDate){
              //   var diffval =  100;
              //   //console.log('not equal');
              // }else {
                //var diffval = diffDuration.minutes()<=0 ? 100 : diffDuration.minutes();
                var diffval = diffTimeStamp<=0 ? 100 : diffTimeStamp;
                //console.log('equal');
              //}
              //console.log('diffDuration -- --> ', list.title +'---> '+diffTimeStamp);
              //console.log('diffDuration -- --', list.title +'---> '+currentDate+'<<->>'+timestampStartDate +' diff ---->'+ diffval);

              let titleMessage: any = searchMeetingTitleHighlight(list, getListInput.searchText);
              let descriptionMessage: any = searchMeetingDescriptionHighlight(list, getListInput.searchText);
              let hostMessage: any = searchMeetingHostNameHighlight(list, getListInput.searchText);
              if(list.ReadFlag){
                var readFlagStatus = list?.ReadFlag[loggedUser?.sip_login_id];
                //console.log("readFlagStatus>>>>>",readFlagStatus);
              }
              return (<div className="Dividerchild" key={index} >
                {
                  moment(list.start_timestamp).format('YYYY/MM/DD') !==
                  moment(meetingList[index - 1]?.start_timestamp).format('YYYY/MM/DD') &&
                  // <Divider plain className="dividerDate">{timeStampConverter(list.start_timestamp, 'group')}</Divider>     
                  <div className={styles.badgecurrentmeet}>
            <div className={styles.badmidlesec}>
                <span>{timeStampConverterMeeting(list.start_timestamp, 'group')}</span>
            </div>
        </div>

                }
                { index === 0 && moment(list.start_timestamp).format('YYYY/MM/DD') ===   moment(new Date()).format('YYYY/MM/DD')&& <div className={styles.badgecurrentmeet}>
            <div className={styles.badmidlesec}>
                <span>Today</span>
            </div>
        </div>}
                <div className={(list.uuid === detailPage.uuid && list.status === "Completed") ?
                  (`${styles.meetingsDetails} ${styles.selected} ${styles.clrrightcomplete} ${styles.completed}`) : (list.uuid === detailPage.uuid && list.status === "Cancelled") ? (`${styles.meetingsDetails} ${styles.selected} ${styles.clrrightcancel} ${styles.canceled}`) :
                    (list.uuid === detailPage.uuid && list.status === "Missed") ? 
                    (`${styles.meetingsDetails} ${styles.selected} ${styles.clrrighttopchange} ${styles.missed}`) :(list.uuid === detailPage.uuid && !list.status.includes(previousMeetingArray)) ? (`${styles.meetingsDetails} ${styles.selected} ${styles.onGoing}`) :
                  (list.status === "Completed" ?
                  `${styles.meetingsDetails} ${styles.completed}` : list.status === "Cancelled" ?           
                    `${styles.meetingsDetails} ${styles.canceled}` : list.status === "Missed" ?
                      `${styles.meetingsDetails} ${styles.missed}` : list.status === "Ongoing Meeting" ?
                        `${styles.meetingsDetails} ${styles.onGoing}` : `${styles.meetingsDetails}`)}>
                  <div className={styles.meetingclickingarea} onClick={() => setDetailPage(list)}>                                                            
                    {/* <div className={styles.meetingsTime}>{
                      (diffval <= 5 && list.status === "Cancelled" && (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? <label className={`${styles.meetingsTime} ${styles.in5mins}`}>In 5 minutes</label>
                       : (diffval <= 15 && list.status === "Cancelled" &&  (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? <label className={`${styles.meetingsTime} ${styles.in15mins}`}>In 15 minutes</label> : 
                    (moment(list.start_timestamp).format('hh:mm A')) + ' - ' +
                (moment(list.rrule !== "" ? RRuleTimeCal(list.start_timestamp, list.duration_minutes) : list.end_timestamp).format('hh:mm A'))
                }
                      {(previousMeetingArray.includes(list.status) || list.status === "Ongoing Meeting") &&
                        <div className={styles.meetingSts} >{list.status}</div>}
                        
                        </div> */}
                      {/* {readFlagStatus===1 && list.status !=="Completed" &&  <span className={styles.unReaddot}></span>} */}
                    {(getListInput?.searchText !== "") ? <div className={styles.meetingsTitle}>

                      <p className={styles.desleftsidetoptitle}>{(titleMessage?.middleMsg !== "") ? <>{titleMessage?.firstMsg}
                        < span className={styles.highlight}>{titleMessage?.middleMsg}</span>{titleMessage?.lastMsg}</> :
                        <>{list?.title}</>}</p>
                        <p className={styles.desleftsidemiddle}>{(descriptionMessage?.middleMsg !== "") ? <>{descriptionMessage?.firstMsg}
                          < span className={styles.highlight}>{descriptionMessage?.middleMsg}</span>{descriptionMessage?.lastMsg}</> :
                          <>{list?.description}</>}</p>
                    </div> :
                      <> <div className={styles.meetingsTitle}>
                        <span className={styles.mt}>{list.title}</span>
                      {list.rrule !==""   &&   <span className={styles.recType}>
                      <span className="icon_flipfill"></span>
                      {list.rrule.includes("FREQ=DAILY")
                        ? "Daily" : list.rrule.includes("FREQ=WEEKLY")
                          ? "Weekly" : list.rrule.includes("FREQ=MONTHLY")
                            ? "Monthly" : "None"}</span>}</div>
                      </>
                    }
                    <div className={styles.meetingsTime}>
                      <span className={`${styles.meetingclock} icon_clock `}></span>
                      {
                      (diffval <= 5 && list.status === "Cancelled" && (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? "In 5 minutes"
                       : (diffval <= 15 && list.status === "Cancelled" &&  (list.status !== "Ongoing Meeting" || list.status === "Missed" || list.status ==="Completed")) ? "In 15 minutes" : 
                    (moment(list.start_timestamp).format('hh:mm A')) + ' - ' +
                (moment(list.rrule !== "" ? RRuleTimeCal(list.start_timestamp, list.duration_minutes) : list.end_timestamp).format('hh:mm A'))
                }
                     
                      <div className={styles.duration}> <span className={styles.greyDot}></span> {convertDuration(list.duration_minutes)}</div> 
                      {readFlagStatus===1 &&   <span className={styles.unReaddot}></span> }
                        </div>
                    <div className={styles.meetingsBottomDet}>
                      <div className={styles.userName}>
                        <img className={styles.greyImg} src={usrcirclegrey} alt="" />
                        <img className={styles.actveImg} src={usrcircleactive} alt="" />
                        {(hostMessage?.middleMsg !== "" && getListInput?.searchText !== "") ?
                          (<>{hostMessage?.firstMsg}<span className={styles.highlight}>{hostMessage?.middleMsg}</span>{hostMessage?.lastMsg}</>)
                          :(<span> {!_.isUndefined(findHostName(list)) ? (findHostName(list)) : (list.sip_id=== userdetails.sip_login_id) ? "You": list.hostName }</span>)
                        }
                      </div>
                      {(previousMeetingArray.includes(list.status) || list.status === "Ongoing Meeting") &&
                        <div className={styles.meetingSts} onClick={() => redirectToMeeting(list)}>{list.status=== "Ongoing Meeting" ?
                        "Ongoing" : list.status}</div>}
                
                    </div>
                  </div>

                  {/* {(list.status === "Start" || list.status === "Join" || list.status === "Cancelled" || list.status==="Ongoing Meeting" || list.status === "Missed" || list.status==="Rejoin") &&
                    <div className={(list.status === "Cancelled" ||list.status === "Missed") ? `${styles.copyInvite} ${styles.reschedule}` : `${styles.copyInvite}`} onClick={() => storeMeetingDetail(list)}>
                      {!previousMeetingArray.includes(list.status) &&
                        <div className={styles.duration} onClick={() => copyInvitationModal(true)}>
                          <span><img src={copyinvite} alt="" /></span>Copy Invitation</div>}
                      <div className={styles.join}>
                        {(!previousMeetingArray.includes(list.status) && (list.status !== "Ongoing Meeting") && (list.status !== "Rejoin"))  &&<URButton className='buttonBlue joinBtn' name={
                          userdetails.sip_login_id === list.sip_id ? "Start" : "Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {list.status === "Ongoing Meeting" && <URButton className='buttonBlue joinBtn' name={"Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {
                          list.status === "Rejoin" && <URButton className='buttonBlue joinBtn' name={"Re-join"
                        } onClick={() => redirectToMeeting(list)}></URButton>
                        }
                        {(list.status === "Cancelled" || list.status ==="Missed") && userdetails.sip_login_id === list.sip_id &&
                          <URButton className='buttonBlue joinBtn' name={
                            userdetails.sip_login_id === list.sip_id && "Reschedule"
                          } onClick={()=>reScheduleMeeting(list)}></URButton>}
                      </div>
                    </div>
                  } */}
                  {(list.status === "Start" || list.status === "Join" ||list.status==="Ongoing Meeting" || list.status==="Rejoin") &&
        <div className={`${styles.copyInvite}`} onClick={() => storeMeetingDetail(list)}>
            {!previousMeetingArray.includes(list.status) &&
                        <div className={styles.duration} onClick={() => copyInvitationModal(true)}>
                          <span><img src={copyinvite} alt="" /></span>Copy Invitation</div>}
                          <div className={styles.join}>
                        {(!previousMeetingArray.includes(list.status) && (list.status !== "Ongoing Meeting") && (list.status !== "Rejoin"))  &&<URButton className='buttonBlue joinBtn' name={
                          userdetails.sip_login_id === list.sip_id ? "Start" : "Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {list.status === "Ongoing Meeting" && <URButton className='buttonBlue joinBtn' name={"Join"
                        } onClick={() => redirectToMeeting(list)}></URButton>}
                        {
                          list.status === "Rejoin" && <URButton className='buttonBlue joinBtn' name={"Re-join"
                        } onClick={() => redirectToMeeting(list)}></URButton>
                        }
                      </div>
          </div>
                  }
                                   {(list.status === "Cancelled" ||list.status === "Missed") && userdetails.sip_login_id === list.sip_id &&
        <div className={`${styles.copyInvite} ${styles.reschedule}`} onClick={() => storeMeetingDetail(list)}>
                           {
                          <URButton className='buttonBlue joinBtn' name={
                            userdetails.sip_login_id === list.sip_id && "Reschedule"
                          } onClick={()=>reScheduleMeeting(list)}></URButton>}
          </div>
                  }
                </div>
              </div>);
            }
            )}
          </div>
          
          {isCopyModal && <CopyInvitePopUp detailPage={detailPage} invitePropsCalling={copyInvitationModal}
            isCopyModal={isCopyModal}/>}
          {/* <Modal visible={isCopyModal} title="Copy Meeting Invitation"
            centered
            onOk={handleOk3}
            onCancel={handleCancel3}
            cancelText="Cancel"
            okText="Copy Invitation"
            cancelButtonProps={{ className: 'urButton buttonWhite' }}
            okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup meetinvite">
            <div className="meetingInviteconsec" id='copyMeeting'>
              <div className="meetingtopheader">
                <h4>Meeting Invitation</h4>
              </div>
              <div className="meetinginnerconsec">
                <p className="boxhead marbtmmin">{`${detailPage.hostName} is inviting
                        you to a scheduled Unifiedring meeting.`} </p>
                <p className="boxhead marbtmmin"><span>Topic: </span><span>{detailPage.title}</span></p>
                <p className="boxhead marbtmmin"><span>Time:</span>
                  <span>
                   {timeStampConverter(detailPage.start_timestamp, 'list')}&nbsp;
                    {moment(detailPage.start_timestamp).format('Do MMMM YYYY h:mm A')}
                    <br />
                    Every 4 weeks on Sun, until Mar 27, 2022, 5 occurrence(s) <br />
                    Dec 5, 2021 01:00 AM<br />
                    Jan 2, 2022 01:00 AM<br />
                    Jan 30, 2022 01:00 AM<br />
                    Feb 27, 2022 01:00 AM<br />
                        Mar 27, 2022 01:00 AM
                  </span>
                </p>
                <p className="boxheadlink marbtmmin">Please download and import the following
                  iCalendar (.ics) files to your calendar system.

                  Weekly:<Link to="/">https://unifiledring.com/meeting/tJEsde6tqzIvH9D7jlfIxTCgs7P
                    fIWRMY_XU/ics?icsToken=98tyKuCtrzktH9GctRyDRowMBYjoKO_wmFhYgvp5yxXpBQlLViDxJbVyNJtIIvXp</Link></p>
                <p className="boxheadlink marbtmmin">Join Unifiedring Meeting <br />
                  <Link to={detailPage.invite_url}>{detailPage.invite_url}</Link></p>
                <p className="boxhead">Meeting ID: {detailPage.meeting_id} <br />Passcode: {detailPage.password} </p>
              </div>
            </div>
          </Modal> */}

{/*           {isLeftBarLoading && <div className="skeletonMeetingbottom"><Lottie className="svgLoading"
            animationData={groovyWalkAnimation} /></div>}  */}
        </> :
          <> {isLeftBarLoading ?
            <>{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((index: any) => (
              <div key={index}><URChatLeftSkeleton />
              </div>
            ))}</> : <NoContent image={noResult}
              title={''}
              description={'No meetings found'} />} </>}



        <Modal visible={isModalVisible} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span className={`icon_close ${styles.cursorTop}`} />
          <h2>Delete this Chat?</h2>
          <p>You cannot retrieve the chat history with UI Designing after deletion</p>
          <div className={styles.footersection}>
            {!previousMeetingArray.includes(meetingList?.status) &&
              <URButton className={styles.cancelbtn} name="Join"></URButton>}
            <URButton className={styles.deletebtn} onClick={handleCancel} name="Delete Chat"></URButton>
          </div>
        </Modal>

      </>
    </div>
 {isLeftBarLoading && meetingList?.length >  0 &&  <div className="skeletonMeetingbottom "><Lottie className="svgLoading"
animationData={ContactLoader}  /></div> }
</>
  );
});

// return (
//   <>
//     <div className={styles.meetingsList}>
//       <Divider plain className="dividerDate">19 Nov</Divider>
//       <div className={`${styles.meetingsDetails} ${styles.selected}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm</div>
//         <div className={styles.meetingsTitle}>Monthly team meet-up</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>

//       <div className={`${styles.meetingsDetails} ${styles.canceled}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm
//           <span className={styles.meetingSts}>Cancelled</span>
//         </div>
//         <div className={styles.meetingsTitle}>Spain launch review</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//       <Divider plain className="dividerDate">23 Nov</Divider>
//       <div className={`${styles.meetingsDetails} ${styles.completed}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm
//           <span className={styles.meetingSts}>Completed</span>
//         </div>
//         <div className={styles.meetingsTitle}>Weekly team meet-up</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>

//       <div className={`${styles.meetingsDetails} ${styles.missed}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm
//           <span className={styles.meetingSts}>Missed</span>
//         </div>
//         <div className={styles.meetingsTitle}>Work shop Group call feature</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//       <div className={`${styles.meetingsDetails}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm</div>
//         <div className={styles.meetingsTitle}>Browser_clarifications</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//       <Divider plain className="dividerDate">Tomorrow</Divider>
//       <div className={`${styles.meetingsDetails}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm</div>
//         <div className={styles.meetingsTitle}>UI Design &quot; UI developers</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//       <Divider plain className="dividerDate">Today</Divider>
//       <div className={`${styles.meetingsDetails}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm</div>
//         <div className={styles.meetingsTitle}>Design &quot; Technical writers</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//       <div className={`${styles.meetingsDetails}`}>
//         <div className={styles.meetingsTime}>5:00 - 6:00 pm</div>
//         <div className={styles.meetingsTitle}>Design_ASR TTS</div>
//         <div className={styles.meetingsBottomDet}>
//           <div className={styles.duration}>3h 20m</div>
//           <div className={styles.userName}><img src={usrcirclegrey} alt="" />Marilyn Adam</div>
//           <div className={styles.recType}><span className="icon_flipfill"></span>Monthly</div>
//         </div>
//         <div className={styles.copyInvite}>
//           <div className={styles.duration} onClick={showModal3}><span className="icon_copydoc"></span>
//             Copy Invitation</div>
//           <div className={styles.join}>
//             <URButton className='buttonBlue joinBtn' name="Join"></URButton>
//           </div>
//         </div>
//       </div>
//     </div>
//     <Modal visible={isModalVisible} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
//       <span className={`icon_close ${styles.cursorTop}`} />
//       <h2>Delete this Chat?</h2>
//       <p>You cannot retrieve the chat history with UI Designing after deletion</p>
//       <div className={styles.footersection}>
//         <URButton className={styles.cancelbtn} name="Join"></URButton>
//         <URButton className={styles.deletebtn} onClick={handleCancel} name="Delete Chat"></URButton>
//       </div>
//     </Modal>
//     <Modal visible={isCopyModal} title="Copy Meeting Invitation"
//       centered
//       onOk={handleOk3}
//       onCancel={handleCancel3}
//       cancelText="Cancel"
//       okText="Copy Invitation"
//       cancelButtonProps={{ className: 'urButton buttonWhite' }}
//       okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup meetinvite">
//       <div className="meetingInviteconsec">
//         <div className="meetingtopheader">
//           <h4>Meeting Invitation</h4>
//         </div>
//         <div className="meetinginnerconsec">
//           <p className="boxhead marbtmmin">Daiyan Baily is inviting you to a scheduled Unifiedring meeting. </p>
//           <p className="boxhead marbtmmin"><span>Topic: </span><span>Hunt group workshop</span></p>
//           <p className="boxhead marbtmmin"><span>Time:</span><span>Dec 5, 2021 01:00 AM India <br />
//             Every 4 weeks on Sun, until Mar 27, 2022, 5 occurrence(s) <br />
//             Dec 5, 2021 01:00 AM<br />
//             Jan 2, 2022 01:00 AM<br />
//             Jan 30, 2022 01:00 AM<br />
//             Feb 27, 2022 01:00 AM<br />
//             Mar 27, 2022 01:00 AM</span>
//           </p>
//           <p className="boxheadlink marbtmmin">Please download and import the following
//             iCalendar (.ics) files to your calendar system.
//             Weekly:<Link to="/">https://unifiledring.com/meeting/tJEsde6tqzIvH9D7jlfIxTCgs7P
//             fIWRMY_XU/ics?icsToken=98tyKuCtrzktH9GctRyDRowMBYjoKO_wmFhYgvp5yxXpBQlLViDxJbVyNJtIIvXp</Link></p>
//           <p className="boxheadlink marbtmmin">Join Unifiedring Meeting <br />
//             <Link to="/">https://unifiledring.com/j/95127559554?pwd=OVI4RlZaUDRqa2w5UThiR0J4WXhwUT09 </Link></p>
//           <p className="boxhead">Meeting ID: 615-375-0127 <br />Passcode: Vs0YxC </p>
//         </div>
//       </div>
//     </Modal>
//   </>
// );
// };


export default MeetingsLists;